import React from 'react';
import {connect} from "react-redux";
import {RESOURCE_ATTACHED_TO_TYPE, SIDEBAR_SHAPE_BUTTONS} from "../../../../../constants";
import Square from "../../../../canvas/core/shapes/layouts/square";
import WideAngle from "../../../../canvas/core/shapes/layouts/wideAngle";
import Horseshoe from "../../../../canvas/core/shapes/layouts/horseshoe";
import Rectangle from "../../../../canvas/core/shapes/layouts/rectangle";
import Dot from "../../../../canvas/core/shapes/layouts/dot";
import sqftConfig from "../../../../canvas/store/sqftConfig";
import sqftShapeManager from "../../../../canvas/store/sqftShapeManager";
import {updateSQFTCalculations} from "../../../../../../../actions/sqftFunctions";
import workspace from "../../../../canvas/core/workspace";
import config from "../../../../canvas/store/sqftConfig";
import {getCountertopPartNames, getEdgeFeatures} from "../../../../../helpers/shapeHelper";
import {attachResource} from "../../../../canvas/core/controls/resourseCanas";
import FreeDraw from "../../../../canvas/core/controls/freeDraw";
import {setSQFTActiveButton} from "../../../../../../../actions/sqftMenuFunctions";
import {getIsSFTAreaGroup} from "../../../../../helpers/sqftNavigationHelper";
import {handleFreeFormClick} from "../../../NavigationHelper";

/**
 * @param {{}} props
 */
const SqftNavShapes = (props) => {
  // other popups, modals and so on
  const {menuOpened, activeButton, setSQFTActiveButton} = props;
  const expanded = activeButton && menuOpened === "shapes";
  // const buttonRefs = useRef({});
  const getSidebarShapesButtons = () => {
    const isSFTAreaGroup = getIsSFTAreaGroup();
    let sidebarShapesButtons = [];
    if (isSFTAreaGroup) {
      sidebarShapesButtons = [
        "square",  "rectangle", "dot", "freeDraw", "shapeFreeForm",
      ];
    } else {
      sidebarShapesButtons = [
        "square", "lshape", "wideangle", "rectangle", "dot", "freeDraw", "shapeFreeForm", // "waterfall"
      ];
    }

    return sidebarShapesButtons
  }

  const handleButtonClick = (shapeName) => {
    console.log(shapeName);
    config.workspace.menuItemActive = shapeName;
    setSQFTActiveButton(shapeName);

    //todo sqft-react remove
    // const draw = (ctx, frameCount) => {
    //   //console.log(shapeName);
    //   //ctx.clearRect(0, 0, ctx.canvas.width, ctx.canvas.height);
    //   ctx.fillStyle = '#000000';
    //   ctx.beginPath();
    //   ctx.arc(500, 500, 20*Math.sin(frameCount*0.05)**2, 0, 2*Math.PI)
    //   ctx.fill();
    // };
    // sqftEventManager.renderEvents.push({
    //   priority: sqftEventManager.priorities.POINT,
    //   name: "circle",
    //   render: draw
    // });

    //debugger // eslint-disable-line no-debugger

    //eventManager.stealCursor(true); //todo
    const [countertopPartName, centerIslandPartName] = getCountertopPartNames();
    switch (shapeName) {
      case "square":
        sqftShapeManager.addShape(new Square(sqftConfig.shapeSize), 'square', null, centerIslandPartName);
        break;
      case "lshape":
        sqftShapeManager.addShape(new WideAngle(sqftConfig.shapeSize), 'wideangle', null, countertopPartName);
        break;
      case "wideangle":
        sqftShapeManager.addShape(new Horseshoe(sqftConfig.shapeSize), 'horseshoe', null, countertopPartName);
        break;
      case "rectangle":
        sqftShapeManager.addShape(new Rectangle(), 'square', null, countertopPartName);
        break;
      case "dot":
        sqftShapeManager.addShape(new Dot(sqftConfig.shapeSize), 'square', null, countertopPartName);
        break;
      case "waterfall":
        addWaterfallLayout();
        break;
      case "freeDraw":
        //setSQFTMenuOpened('');
        handleFreeDrawClick()
        break;
      case SIDEBAR_SHAPE_BUTTONS.shapeFreeForm:
        handleFreeFormClick();
        break;
      default:
        break;
    }

    if (window.innerHeight < 480 && window.innerWidth < 991) {
      //Menu.hideSidebarSide(); //todo sqft-react
      //Menu.hideSideBarContent(); //todo sqft-react
    }
  };

  const handleFreeDrawClick = function () {
    FreeDraw.init();
  };

  const addWaterfallLayout = () => {
    const vc = workspace.getVisibleCenter();
    const scale = config.defaultScale;// * config.defaultScale
    const navItems = getEdgeFeatures();
    const navItemMitered = navItems.find(edge => edge.part.getFeatureName().toLowerCase().includes('miter')); // MITER EDGE
    const [countertopPartName, centerIslandPartName] = getCountertopPartNames();
    void centerIslandPartName;
    let posOnFiled;

    //CreateShapes
    posOnFiled = {x: vc.x - 200 / scale, y: vc.y + 57 / scale};
    let shapeId = sqftShapeManager.addShape(new Rectangle(36, 4), 'square', posOnFiled,countertopPartName);
    if (navItemMitered) {
      addEdgeToTheLines(shapeId, navItemMitered.part, [2])
    }

    posOnFiled = {x: vc.x - 200 / scale, y: vc.y - 100 / scale};
    shapeId = sqftShapeManager.addShape(new Rectangle(36, 20), 'square', posOnFiled, countertopPartName);
    if (navItemMitered) {
      addEdgeToTheLines(shapeId, navItemMitered.part, [0])
    }

    posOnFiled = {x: vc.x, y: vc.y - 200 / scale};
    shapeId = sqftShapeManager.addShape(new Rectangle(36, 4), 'square', posOnFiled, countertopPartName);
    if (navItemMitered) {
      addEdgeToTheLines(shapeId, navItemMitered.part, [0, 1, 2])
    }

    posOnFiled = {x: vc.x + 320 / scale, y: vc.y - 100 / scale};
    shapeId = sqftShapeManager.addShape(new Rectangle(36, 48), 'square', posOnFiled, countertopPartName);
    if (navItemMitered) {
      addEdgeToTheLines(shapeId, navItemMitered.part, [1, 3])
    }

    posOnFiled = {x: vc.x, y: vc.y + 150 / scale};
    shapeId = sqftShapeManager.addShape(new Rectangle(36, 4), 'square', posOnFiled, countertopPartName);
    if (navItemMitered) {
      addEdgeToTheLines(shapeId, navItemMitered.part, [0, 1, 2])
    }

    posOnFiled = {x: vc.x, y: vc.y - 100 / scale};
    shapeId = sqftShapeManager.addShape(new Rectangle(65, 48), 'square', posOnFiled, countertopPartName);
    if (navItemMitered) {
      addEdgeToTheLines(shapeId, navItemMitered.part, [0, 1, 2])
    }
  }

  const addEdgeToTheLines = (shapeId, edge, lineNumbers) => {
    const shape = workspace.getShapeById(shapeId);
    const lines = shape.getLines();

    lines.forEach((line, index) => {
      if (lineNumbers.includes(index)) {
        //line.addEdgeToLine(edge.getFeatureName(), edge.dbFeature.id); // old functional
        attachResource(line, null, RESOURCE_ATTACHED_TO_TYPE.edge, edge.dbFeature.id, null, edge.getFeatureName());
      }
    })
  }

  return (
    <div className={"shapes side" + (menuOpened && activeButton && activeButton === "shapes" ? " expanded" : "")} data-side="shapes">
      <div className="shapes-list">
        {expanded ?
          getSidebarShapesButtons().map((item, index) => (
            <button key={index}
                    // ref={el => buttonRefs.current[index] = el}
                    className={"animated fadeInUp button button--inner shapes-icon button--" + item}
                    onClick={() => handleButtonClick(item)}
                    data-shape={item}>
            </button>
          ))
        : null}
      </div>
    </div>
  )
};

const mapStateToProps = (store) => ({
  updateCalculations: store.sqftState.updateCalculations,
  language: store.serverState.language,
  menuOpened: store.sqftMenuState.menuOpened,
  activeButton: store.sqftMenuState.activeButton
});

const mapDispatchToProps = {
  updateSQFTCalculations,
  setSQFTActiveButton,
};


export default connect(mapStateToProps, mapDispatchToProps)(SqftNavShapes);
